// A place to drop files, which is also a button to choose them.
//
// The whole zone is one button with the hidden file input behind it, so a keyboard reaches it
// as a control and a screen reader hears one thing. Drag state is on the element while a drag is
// over it and nowhere else - the browser fires dragenter/dragleave for every child crossed, so the
// count of enters minus leaves is what "over" means, not the last event.

import { useRef, useState } from 'react';

import Icon from './Icon.jsx';

export default function DropZone({ onFiles, accept, multiple = true, disabled = false, hint, children }) {
  const input = useRef(null);
  const [depth, setDepth] = useState(0);
  const over = depth > 0 && !disabled;

  const choose = (files) => {
    if (!disabled && files && files.length > 0) onFiles(files);
  };

  return (
    <div
      className={`drop-zone${over ? ' over' : ''}${disabled ? ' disabled' : ''}`}
      onDragEnter={(event) => {
        event.preventDefault();
        setDepth((d) => d + 1);
      }}
      onDragOver={(event) => event.preventDefault()}
      onDragLeave={() => setDepth((d) => Math.max(0, d - 1))}
      onDrop={(event) => {
        event.preventDefault();
        setDepth(0);
        choose(event.dataTransfer.files);
      }}
    >
      <button type="button" className="drop-zone-button" disabled={disabled}
              onClick={() => input.current?.click()}>
        <Icon name="upload" />
        <span>{children}</span>
        {hint && <small>{hint}</small>}
      </button>
      <input
        ref={input}
        type="file"
        accept={accept}
        multiple={multiple}
        hidden
        onChange={(event) => {
          choose(event.target.files);
          // So the same file can be chosen again after being removed from the list.
          event.target.value = '';
        }}
      />
    </div>
  );
}
